import React from 'react';
import DataSetRecipeTab from 'js/components/data_sets/cards/DataSetRecipeTab';
import styles from './RulesTab.module.scss';

interface RulesTabProps {
  dataset: {
    id: number;
    parent_data_set_id?: number;
    custom_config?: {
      txSpec?: {
        v: number;
        spec: any[];
      };
    };
    node_type?: string;
    [key: string]: any;
  };
}

export const RulesTab = ({ dataset }: RulesTabProps) => {
  if (!dataset) {
    return (
      <div className={styles.detailLayout}>
        <div className={styles.mainCol}>
          <div className="detail-view">
            <div className="tab-content">
              <p>No dataset information available.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <DataSetRecipeTab data={dataset} />;
};

RulesTab.displayName = 'RulesTab';
